if (!Enum) {
    var Enum = {};
}

Enum.RECEIVER_TYPE = { // AUTHORIZED_PERSON, GUARDIAN, AUTHORIZED_ORGAN, PATIENT
    AUTHORIZED_PERSON: 'AUTHORIZED_PERSON',
    GUARDIAN: 'GUARDIAN',
    AUTHORIZED_ORGAN: 'AUTHORIZED_ORGAN',
    PATIENT: 'PATIENT'
};

Object.freeze(Enum.RECEIVER_TYPE);